import {initialSettings} from './initialSettings';
import {cleanup} from './cleanup';

export const remoteControl: RemoteControlService = {
  initialSettings,
  cleanup,
};
